var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar-menu',[_c('v-spacer'),_vm._v(" "+_vm._s(_vm.version)+" ")],1),_c('alert',{ref:"snackbar"}),_c('simple-dialog',{ref:"simpleDialog"}),_c('app-menu'),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }